import { render, staticRenderFns } from "./Invitations.vue?vue&type=template&id=d3cd8af8&"
import script from "./Invitations.vue?vue&type=script&lang=js&"
export * from "./Invitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports